<template>
    <BreadCrumb PageTitle="Listes des abonnements" />
    <ListeAbonnement />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeAbonnement from "../../components/Abonnement/ListeAbonnement.vue";
  
  
  export default defineComponent({
    name: "ListeAbonnePage",
    components: {
      BreadCrumb,
      ListeAbonnement,
    },
  });
  </script>